<template>
  <DoubleColumn v-if="resource">
    <template #header>
      <PracticeHeader :practice="resource" />
    </template>
    <template #left>
      <TabsPanel v-if="resource">
        <template #items>
          <TabsPanelItem :to="{name: 'practices.show.overview', params: {id: id}}">
            Übersicht
          </TabsPanelItem>
          <TabsPanelItem :to="{name: 'practices.show.context', params: {id: id}}" :disabled="!resource.setup_context">
            Einordnung
          </TabsPanelItem>
          <TabsPanelItem :to="{name: 'practices.show.actions', params: {id: id}}" :disabled="!resource.setup_actions">
            Anleitung
          </TabsPanelItem>
          <TabsPanelItem :to="{name: 'practices.show.rating', params: {id: id}}" :disabled="!resource.setup_rating">
            Potential
          </TabsPanelItem>
          <TabsPanelItem :to="{name: 'practices.show.experiments', params: {id: id}}">
            Experimente
          </TabsPanelItem>
        </template>
        <template #main>
          <router-view :practice="resource">
          </router-view>
        </template>
      </TabsPanel>
    </template>
    <template #right>
      <PracticeMenu :practice="resource" />
      <CompilationsWidget :practice="resource" />
      <SimilaritiesWidget :practice="resource" />
    </template>
  </DoubleColumn>
</template>

<script setup>
import { computed, onMounted, ref, watch } from 'vue';
import { useRetrieveResource } from '@/client/actions';
import { useStore } from 'vuex';

const props = defineProps({id: String});
const store = useStore();

const model = computed(() => props.id);
const parent = computed(() => store.getters['context/context'].id);
const target = computed(() => '/api/podcasts/' + parent.value + '/practices/' + props.id);

const action = useRetrieveResource(target);

const { resource, retrieve, retrieving } = action;

const mounted = onMounted(() => retrieve());
const watchModel = watch(model, (_) => retrieve());
const watchParent = watch(parent, (_) => retrieve());
</script>

